<template>
    <div :key="rowId" class="table-cell-wrapper_content / flex">
        <NuxtLink v-if="isNavigable" :to="renewalLink" external class="renewal-status-badge-link" data-testid="renewal-status-badge-link">
            <VJoyBadge
                bulletpoint
                :variant="renewalStatusVariant"
                :label="t(`projectclient.projectlist.table.renewalStatus.value.${props.renewalStatus!!}`).toLowerCase()"
            />
        </NuxtLink>
        <VJoyBadge
            v-else-if="isInitialized"
            bulletpoint
            :variant="renewalStatusVariant"
            :label="t(`projectclient.projectlist.table.renewalStatus.value.${props.renewalStatus!!}`).toLowerCase()"
        />
        <span v-else>-</span>
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {NuxtLink} from '#components';
    import {useTranslation, useGuestHost} from '#imports';
    import {VJoyBadge} from '@maltjoy/core-vue';
    import {RenewalStatus} from '@api';

    const {t} = useTranslation();
    const host = useGuestHost();

    const props = defineProps<{
        rowId: string;
        renewalStatus?: RenewalStatus;
        renewalTargetCorrelationId?: string;
    }>();

    const isInitialized = computed(() => {
        return props.renewalStatus != undefined && props.renewalStatus != RenewalStatus.NotInitialized;
    });

    const isNavigable = computed(() => {
        return !!props.renewalTargetCorrelationId;
    });

    const renewalLink = computed(() => `${host}/project-client/project?correlationId=${props.renewalTargetCorrelationId}`);

    const renewalStatusVariant = computed(() => {
        switch (props.renewalStatus) {
            case RenewalStatus.PendingDecision:
                return 'yellow';
            case RenewalStatus.Declined:
                return 'gray';
            case RenewalStatus.AwaitingQuote:
                return 'dark-blue';
            case RenewalStatus.ToApprove:
                return 'pink';
            case RenewalStatus.Renewed:
                return 'green';
            case RenewalStatus.RefusedByFreelancer:
                return 'red';
            case RenewalStatus.RefusedByClient:
                return 'red';
            default:
                return 'gray';
        }
    });
</script>

<style lang="scss" scoped>
    .table-cell-wrapper_content {
        flex-flow: row nowrap;
    }

    .renewal-status-badge-link {
        color: inherit;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .table_status_tooltip {
        margin-left: var(--joy-core-spacing-2);
        margin-top: 3%;
    }
</style>
